<template>
  <div class="qrcode-wrp">
    <div class="two-dimensional-code">
      <!-- <QRcode v-if="qrCodeUrl" ref="qrCode" width="400" height="400" title="二维码" :url="qrCodeUrl"/> -->
      <img v-if="qrCodeUrl" :src="qrCodeUrl" class="code"/>
      <div class="code" v-else></div>
      <div class="refresh" @click="refreshQrCode">刷新二维码</div>
      <div class="logintips">
        <p>请使用电子税局APP扫码登录</p>
        <p>扫码人脸登录成功后请点击下方确认按钮</p>
        <p>若二维码失效请点击上方刷新按钮重新扫码</p>
      </div>
      <div class="get-result" @click="checkLoginResult">验证登录结果</div>
    </div>
    <p class="error-message">{{errorText}}</p>
    <div class="footer">
      <van-button
        class="btn"
        :loading="btnLoading"
        type="info"
        loading-text="保存中..."
        @click="handleSaveImg"
      >
        保存到相册
      </van-button>
    </div>
  </div>
</template>

<script>
import { RadioGroup, Radio, Button, Toast, Notify } from 'vant'
import { mapActions, mapState, mapMutations } from 'vuex'
import { invoiceRequest } from '@/services'
import { download } from '@utils/basicUtil'
const namespace = 'eTaxLogin'
export default {
  components: {
    [RadioGroup.name]: RadioGroup,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Radio.name]: Radio,
  },
  props: {
    getLoginResults: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      btnLoading: false,
      loading: false,
      loginParams: {
        loginType: 1,
        taxPersonnelPhone: '',
        sid: ''
      },
      qrCodeUrl: '',
      countDown: 60,
      errorVisible: '',
      errorText: '',
      showSuccess: false
    }
  },
  computed: {
    ...mapState(namespace, ['certificationResults']),
  },
  watch: {},
  created () {},
  async mounted () {
    await this.getAuthInfo()
    this.onInputChange({ field: 'taxPersonnelPhone', e: this.certificationResults.taxPersonnelPhone})
    this.getLoginQrCode()
  },
  activated () {},
  updated () {},
  methods: {
    ...mapActions(namespace, ['getAuthInfo']),
    onInputChange ({ e, field }) {
      this.loginParams = {
        ...this.loginParams,
        [field]: e
      }
    },
    async checkLoginResult () {
      Toast.loading({
        message: '验证中...',
        forbidClick: true,
        duration: 0
      })
      const res = await invoiceRequest.allElectricLogin.asyncGetQrCodeStatus({
        loginType: 1,
        verifyAppType: Math.abs(this.loginParams.loginType), // app类型 1-电子税局 2-个人所得税 3-电子营业执照 4-粤税通
        sid: this.sid
      })
      if (res.success) {
        console.log(res.result, 'res.result')
        if (res.result.status === 1) { // 登录成功
          this.getLoginResults()
        } else { //登录失败
          this.errorVisible = true
          this.errorText = res.result.message
        }
      } else {
        if (res.message) Notify({ type: 'danger', message: res.message })
      }
      Toast.clear()
    },
    /**
     * 获取电子税局登录二维码接口
     */
    async getLoginQrCode(ewmlx = 0) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      this.loading = true
      this.errorVisible = false
      this.errorText = ''
      const res = await invoiceRequest.allElectricLogin.asyncAutonomousLogin({
        loginType: 1,
        ewmlx, //获取二维码类型 1-强制刷新 0-自动获取
        verifyAppType: Math.abs(this.loginParams.loginType), // app类型 1-电子税局 2-个人所得税 3-电子营业执照 4-粤税通
      })
      if (res.success) {
        if (res.result.status === 1) {// 登录成功，需要查左上角接口，获取最新登录时间
          Notify({ type: 'success', message: '登录成功' })
          this.getLoginResults()
        } else if (res.result.status === 2) { // 登录失败
          this.errorVisible = true
          this.errorText = res.result.message
          this.sid = res.result.sid
          Notify({ type: 'danger', message: res.result.message })
        } else if (res.result.status === 4) { // 需要补充短信验证码
          this.qrCodeUrl = res.result.ewm || '1'
          this.sid = res.result.sid
        }
      } else {
        if (res.message) Notify({ type: 'danger', message: res.message })
      }
      this.loading = false
      Toast.clear()
    },
    handleSaveImg () {
      download({ url: this.qrCodeUrl, title: '二维码' })
    },
    refreshQrCode () {
      this.getLoginQrCode(1)
    },
  }
}
</script>
<style scoped lang='less'>
.qrcode-wrp{
  .two-dimensional-code{
    .code{
      width: 400px;
      height: 400px;
    }
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .get-result{
      margin-top: 24px;
      font-size: 28px;
      justify-content: center;
      color: #297CF0;
    }
    .result{
      width: 88%;
      margin: 0 auto;
      padding: 14px;
      box-sizing: border-box;
    }
    .result > div{
      display: flex;
      margin-bottom: 16px;
      font-size: 28px;
      .label{
        width: 160px;
      }
      .value{
        flex-grow: 1;
        width: 0;
        word-wrap: break-word;
      }
    }
    .qrcode{
      width: 520px;
      height: 520px;
    }
  }
  .error-message{
    font-size: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #F65440;
    line-height: 34px;
    text-align: left;
  }
  .footer{
    margin: 24px 0;
    .btn{
      padding: 16px 0;
      width: 100%;
      height: 100%;
      border-radius: 40px;
      font-size: 32px;
    }
  }
}
.title {
  margin-top: 38px;
  font-size: 38px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}
.describe {
  margin-top: 60px;
  font-size: 28px;
  font-weight: 400;
  color: #666;
  .tip{
    color: #297CF0;
  }
}
.refresh {
  margin-bottom: 12px;
  color: #297CF0;
  font-size: 28px;
}
.logintips{
  width: 100%;
  background: rgba(41, 124, 240, 0.05);
  padding: 24px 0;
  font-size: 24px;
  text-align: center;
  color: #666666;
}
</style>
